const getEnv = (key: keyof ImportMetaEnv, fallback = ''): string => {
  const value: unknown = import.meta.env[key];
  return typeof value === 'string' ? value : fallback;
};

export const env = {
  API_URL: getEnv(
    'VITE_API_URL',
    'https://pro20api.pro20officialapi01.it/api/v1',
  ),
  FRONTEND_URL: getEnv('VITE_FRONTEND_URL', ''),
  GOOGLE_PLACES_API_KEY: getEnv('VITE_GOOGLE_PLACES_API_KEY', ''),
  WHATSAPP_API_URL: getEnv(
    'VITE_WHATSAPP_API_URL',
    'https://whatsappapistaging.pro20officialapi01.it',
  ),
  WHATSAPP_WS_URL: getEnv(
    'VITE_WHATSAPP_WS_URL',
    'wss://whatsappapistaging.pro20officialapi01.it/api/v1/ws/messages',
  ),
  FB_APP_ID: getEnv('VITE_FB_APP_ID', '1347303146561946'),
  FB_CONFIG_ID: getEnv('VITE_FB_CONFIG_ID', '1209782427367742'),
  FB_GRAPH_VERSION: getEnv('VITE_FB_GRAPH_VERSION', 'v24.0'),
  APP_NAME: getEnv('VITE_APP_NAME', 'PRO20 Admin'),
  APP_ENV: getEnv('VITE_APP_ENV', 'development'),
  APP_VERSION: getEnv('VITE_APP_VERSION', '2.0.76'),
  BACKOFFICE2020_ACCESS_CODE: getEnv(
    'VITE_BACKOFFICE2020_ACCESS_CODE',
    '202020',
  ),
  /** RSA public key PEM for encrypting panel sign-in payloads. */
  PANEL_PUBLIC_KEY: getEnv('VITE_PANEL_PUBLIC_KEY', '').replace(/\\n/g, '\n'),
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
} as const;
